import React from 'react';
import Carousel from 'react-slick';
import Hidden from '@material-ui/core/Hidden';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CarouselDesktop from 'components/RecentActivityCarouselDesktop.jsx';
import TrackLinkItem from 'components/TrackLinkItem';

const settings = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
};

export const RecentActivity = ({ list }) => (
  <Card
    blue
    style={{
      borderRadius: '0px',
    }}
    paper='true'
  >
    <CardHeader paper='true'>
      <h4 style={{ margin: '10px 0px 0px 5px' }}>
        <b>Recent Activity</b>
      </h4>
    </CardHeader>
    <CardBody style={{ padding: '.5rem 20px 2.5rem 20px' }} paper='true'>
      <GridContainer justify='center'>
        <GridItem xs={12}>
          <GridContainer style={{ margin: '0px 0px 20px 0px' }}>
            <GridItem xs={12}>
              <Hidden xsDown implementation='css'>
                <div
                  style={{
                    padding: '0px 0px 0px 0px',
                    margin: '0px 0px 20px 0px',
                    borderRadius: '20px',
                  }}
                >
                  <CarouselDesktop list={list} />
                </div>
              </Hidden>
              <Hidden smUp implementation='css'>
                <div
                  style={{
                    padding: '0px 0px 0px 0px',
                    margin: '0px 20px 20px -25px',
                    borderRadius: '20px',
                  }}
                >
                  <Carousel
                    style={{
                      borderRadius: '15px',
                    }}
                    {...settings}
                    id='home'
                  >
                    {list.map((data, index) => (
                      <GridItem xs={12} key={index}>
                        <TrackLinkItem data={data} index={index} />
                      </GridItem>
                    ))}
                  </Carousel>
                </div>
              </Hidden>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </CardBody>
  </Card>
);

export default RecentActivity;
